import { useDispatch, useSelector } from 'react-redux';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { makeStyles } from '@mui/styles';
import Typography from '@mui/material/Typography';
import { ReactElement } from 'react';
import Button from '@mui/material/Button';

const useStyles = makeStyles(() => ({
  root: {
    direction: 'rtl',
  },
  paper: {
    minWidth: '400px',
    padding: '1rem',
    borderRadius: '1rem !important',
  },
  paperWidthSm: {
    maxWidth: '518px',
  },
}));

const _Dialog = (): ReactElement => {
  const dispatch = useDispatch();
  const {
    open,
    title,
    maxWidth,
    message,
    okText,
    cancelText,
    okButtonType,
    cancelButtonType,
    okAction,
    cancelAction,
  } = useSelector((state: any) => state.util.dialog);

  const classes = useStyles();

  const handleClose = () => {
    dispatch.util.setDialog({
      open: false,
    });
  };

  return (
    <Dialog
      open={open}
      maxWidth={maxWidth}
      onClose={cancelAction || handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      classes={classes}
    >
      <DialogTitle className="" id="alert-dialog-title">
        <Typography className="text-lg text-gray-800 font-bold">
          {title}
        </Typography>
      </DialogTitle>

      <DialogContent>
        <Typography className="text-xs xl:leading-6 lg:leading-3 font-medium text-gray-700 text-right">
          {message}
        </Typography>
      </DialogContent>
      <DialogActions dir="rtl" className="flex justify-center">
        {okText && (
          <Button color="primary" variant={okButtonType} onClick={okAction}>
            {okText}
          </Button>
        )}

        {cancelText && (
          <Button
            color="primary"
            variant={cancelButtonType}
            onClick={cancelAction || handleClose}
          >
            {cancelText}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default _Dialog;
